import axios from "axios";
import {  baseURL } from "./configs.js";

const apiUrl = import.meta.env.VITE_APP_API
  // const access_token = JSON.parse(localStorage.getItem("faceAuthTokenData"))
  //   ?.token.access

// axios.defaults.baseURL="http://localhost:5000";
const instance = axios.create({
    baseURL: apiUrl,
    // baseURL: "http://127.0.0.1:8000"

});

instance.interceptors.request.use(
  (config) => {
    const access_token = JSON.parse(localStorage.getItem("faceAuthTokenData"))
      ?.token?.access;

    if (access_token) {
      config.headers.Authorization = `Bearer ${access_token}`;
    }

    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);
export default instance;
